<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 summary-of-charges">
        <div class="white_box py_52 px_50 shipping_fl_left">
            <h1 class="heading1">4. Summary Of Additional Charges</h1>
            
            <!-- Charges Table -->
            <div class="charges-table-section mt-4">
                <table class="table table-bordered charges-table">
                    <thead>
                        <tr>
                            <th class="item-col">Item</th>
                            <th class="qty-col text-left">Qty</th>
                            <th class="cost-col text-left">Cost</th>
                            <th class="total-col text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total Items</td>
                            <td>{{ totalItemsCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr>
                        <!-- <tr>
                            <td>Splitting Charges</td>
                            <td>{{ totalItemsCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr> -->
                        <tr v-if="isSplitShipment && chargeableAddressCount > 0">
                            <td>Split Shipment Fee per address over ({{ totalAddressesWithProducts }}) Addresses</td>
                            <td>{{ chargeableAddressCount }}</td>
                            <td class="text-right">{{ splitShipmentFeePerAddressFormatted }}</td>
                            <td class="text-right">{{ splitShipmentFeeTotalFormatted }}</td>
                        </tr>
                        <!-- <tr>
                            <td>Packaging - {{ packagingBoxType }}</td>
                            <td>{{ splitAddressesCount }}</td>
                            <td>-</td>
                            <td class="text-right">-</td>
                        </tr> -->
                        <tr class="total-row">
                            <td colspan="3"><strong>Total Additional Charges (Splitting and Packing)</strong></td>
                            <td class="total-row-value text-right"><strong>{{ totalAdditionalChargesFormatted }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Disclaimer -->
            <div class="disclaimer mt-0">
                <p class="text-muted small">
                    Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SummaryOfAdditionalCharges",
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        splitAddresses() {
            const splitShipmentModule = this.$store.state.splitShipment;
            const addresses = splitShipmentModule && splitShipmentModule.splitAddresses;
            return Array.isArray(addresses) ? addresses : [];
        },
        splitAddressesCount() {
            return this.splitAddresses.length;
        },
        productAssignments() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments || {};
        },
        totalItemsCount() {
            // Count total assigned items
            let total = 0;
            Object.keys(this.productAssignments).forEach(key => {
                if (this.productAssignments[key] && this.productAssignments[key].selected) {
                    total += this.productAssignments[key].quantity || 1;
                }
            });
            return total;
        },
        packagingOptions() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.packagingOptions || {
                boxType: 'standard',
                specialHandling: false
            };
        },
        packagingBoxType() {
            const boxType = this.packagingOptions.boxType || 'standard';
            return boxType.charAt(0).toUpperCase() + boxType.slice(1) + ' Box';
        },
        // Addresses that have at least one product assigned
        totalAddressesWithProducts() {
            const assignments = this.productAssignments || {};
            const indices = new Set();
            Object.keys(assignments).forEach(key => {
                const a = assignments[key];
                if (a && a.selected && a.addressIndex !== undefined) indices.add(a.addressIndex);
            });
            return indices.size;
        },
        // First address free; charge for (count - 1)
        chargeableAddressCount() {
            const n = this.totalAddressesWithProducts;
            return n <= 1 ? 0 : n - 1;
        },
        splitShipmentFeePerAddress() {
            const opt = this.$store.getters.getAdminOption && this.$store.getters.getAdminOption('split_shipment_fee_per_address');
            const val = opt && opt.option_value != null ? String(opt.option_value).replace(/[^0-9.]/g, '') : '';
            return parseFloat(val) || 0;
        },
        splitShipmentFeePerAddressFormatted() {
            return this.chargeableAddressCount > 0 ? '$' + this.splitShipmentFeePerAddress.toFixed(2) : '-';
        },
        splitShipmentFeeTotal() {
            return this.chargeableAddressCount * this.splitShipmentFeePerAddress;
        },
        splitShipmentFeeTotalFormatted() {
            return this.chargeableAddressCount > 0 ? '$' + this.splitShipmentFeeTotal.toFixed(2) : '-';
        },
        totalAdditionalChargesFormatted() {
            const total = this.splitShipmentFeeTotal || 0;
            return total > 0 ? '$' + total.toFixed(2) : '-';
        }
    }
};
</script>

<style scoped>
.summary-of-charges {
    padding: 20px 0;
}

.summary-of-charges .white_box {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.summary-of-charges .heading1 {
    font-size: 20px;
    font-weight: 600;
    color: #121212;
    line-height: 24px;
    margin-bottom: 4px;
}

.summary-of-charges .charges-table-section {
    margin-top: 24px;
    /* Scrollable body with sticky header */
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: auto;
    margin-bottom: 50px;
}

.summary-of-charges .charges-table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    margin-bottom: 0px;
}

.summary-of-charges .charges-table thead th {
    background: #F4F4F4;
    font-weight: 600 ;
    font-size: 14px;
    color: #121212;
    padding: 12px 16px;
    border: none;
    border: 1px solid #BEBEBE4D;
    vertical-align: middle;
    position: sticky;
    top: 0;
    z-index: 1;
}

.summary-of-charges .charges-table .item-col {
    text-align: left;
}

.summary-of-charges .charges-table .qty-col,
.summary-of-charges .charges-table .cost-col,
.summary-of-charges .charges-table .total-col {
    text-align: right;
}

.summary-of-charges .charges-table tbody td {
    padding: 12px 16px;
    border: 1px solid #BEBEBE4D;
    vertical-align: middle;
    font-size: 14px;
    color: #121212;
    font-weight: 500;
}

.summary-of-charges .charges-table tbody tr:last-child td {
    border-bottom: none;
}

.summary-of-charges .charges-table .total-row td {
    font-weight: 700;
    font-size: 16px;
    color: #121212;
}
.summary-of-charges .charges-table .total-row{
    border-bottom: 1px solid #BEBEBE4D; 
}
.summary-of-charges .charges-table .total-row td .total-row-value{
    font-size: 24px;
    font-weight: 700;
}
.summary-of-charges .charges-table .total-row td:last-child {
    font-size: 16px;
    font-weight: 700;
}

.summary-of-charges .disclaimer {
    font-size: 12px;
    color: #6b6b6b;
    font-style: italic;
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.summary-of-charges .disclaimer p,
.summary-of-charges .disclaimer .text-muted {
    margin: 0;
    line-height: 1.6;
    color: #6b6b6b;
}
.summary-of-charges .heading1{
    font-size: 20px !important;
}
</style>
